import React from 'react';
import './PhaseBadge.css';

const PHASE_CONFIG = {
  preclinical:   { label: 'Preclinical',   className: 'phase-preclinical' },
  ind_filed:     { label: 'IND Filed',     className: 'phase-preclinical' },
  phase1:        { label: 'Phase 1',       className: 'phase-1' },
  phase1b:       { label: 'Phase 1b',      className: 'phase-1' },
  phase1_2:      { label: 'Phase 1/2',     className: 'phase-1' },
  phase2:        { label: 'Phase 2',       className: 'phase-2' },
  phase2b:       { label: 'Phase 2b',      className: 'phase-2' },
  phase2_3:      { label: 'Phase 2/3',     className: 'phase-2' },
  phase3:        { label: 'Phase 3',       className: 'phase-3' },
  nda_bla_filed: { label: 'NDA/BLA Filed', className: 'phase-3' },
  approved:      { label: 'Approved',      className: 'phase-approved' },
  discontinued:  { label: 'Discontinued',  className: 'phase-discontinued' },
};

function PhaseBadge({ phase }) {
  if (!phase) return <span className="phase-badge phase-unknown">—</span>;

  const key = phase.toLowerCase().replace(/\s+/g, '');
  const config = PHASE_CONFIG[key] || { label: phase, className: 'phase-unknown' };

  return (
    <span className={`phase-badge ${config.className}`}>
      {config.label}
    </span>
  );
}

export default PhaseBadge;
